"use client";

import {getApp, getApps, initializeApp} from "firebase/app";
import {firebaseConfig} from "./config";
import {browserPopupRedirectResolver, getAuth} from "firebase/auth";

// Prevent Firebase from proactively loading iframe.js (~90 KB).
// The resolver is lazily initialized in auth.ts before popup/redirect sign-in.
// https://github.com/firebase/firebase-js-sdk/issues/4946#issuecomment-1918193756
if (typeof window !== 'undefined' && browserPopupRedirectResolver) {
    Object.defineProperty(
        (browserPopupRedirectResolver as any).prototype, // eslint-disable-line @typescript-eslint/no-explicit-any
        '_shouldInitProactively',
        { get: () => false, configurable: true },
    );
}

export function getFirebaseAuth() {
    if (!getApps().length) {
        const firebaseApp = initializeApp(firebaseConfig);
        return getAuth(firebaseApp);
    }
    const firebaseApp = getApp();
    return getAuth(firebaseApp);
}

